import type { ComponentType } from 'react';

import { type SwitchProps } from '@material-ui/core/Switch/'

import { ToggleStyled } from './styles/ToggleStyled'

export interface IToggleProps extends SwitchProps {
  yes?: string
  no?: string
  ['aria-label']?: string
}

export const Toggle: ComponentType<IToggleProps> = (props) => (
  <ToggleStyled {...props} />
)
Toggle.displayName = 'Toggle'
Toggle.defaultProps = {
  yes: 'Yes',
  no: 'No',
}
